<template>
    <select v-model="selectedValue" class="input-select" :class="selectedValue ? 'text-white' : 'text-gray-400'">
        <option value="" disabled selected>Sélectionner</option>
        <option class="text-black text-left" v-for="option in options" :key="option" :value="option">
            {{ option }}
        </option>
    </select>
</template>

<script>
export default {
    name: "MoleculeSelectInput",
    props: {
        value: String,
        options: Array,
    },
    data() {
        return {
            selectedValue: this.value
        };
    },
    watch: {
        selectedValue(newValue) {
            this.$emit("input", newValue);
        },
        value(newValue) {
            this.selectedValue = newValue
        }
    }
}
</script>

<style scoped>
.input-select {
    @apply bg-transparent border border-white border-opacity-10 rounded-full py-2 px-4 pr-8 w-full md:w-auto text-left;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("../../../../img/down.png");
    background-repeat: no-repeat;
    background-position-x: 90%;
    background-position-y: 16px;
}
</style>
